// extracted by mini-css-extract-plugin
module.exports = {"panel-rule":"_2F4vw5H5XYfhTBOR9E0Fca","panel-rule--large":"Bl9O-kBx5HwXrBBLx-5Xn"};